import { type BgpCommunitiesProtocol, isNonNullable } from '@ipfabric/utils';
import { bgpProtocols } from 'components/BgpSettings/dataTransfer/bgpDataTransferTypes';
import { z } from 'zod';

export const bgpFieldValues = z
  .object({
    id: z.string(),
    // device serial number
    sn: z.string().min(1, 'Serial number is required'),
    protocol: z.enum(bgpProtocols).nullable().refine(isNonNullable, {
      message: 'Protocol is required',
    }),
    vrf: z.string().transform((s) => (s === '' ? null : s)),
    isVrfStd: z.boolean(),
    communityList: z
      .string()
      .min(1, 'Community list is required')
      .regex(
        /^((\d{1,9})(:(\d{1,9}))?)?(,\d{1,9}(:(\d{1,9}))?)*$/,
        'Community list should be comma-separated ASN values',
      )
      .transform((s) => s.split(',')),
  })
  .superRefine((data, ctx) => {
    if (!data.isVrfStd && !data.vrf) {
      ctx.addIssue({
        message: 'Provide custom or native VRF name',
        path: ['vrf'],
        code: z.ZodIssueCode.custom,
      });
    }
  });

export type BgpFieldValues = {
  communityList: string;
  id: string;
  isVrfStd: boolean;
  protocol: BgpCommunitiesProtocol | null;
  sn: string;
  vrf: string;
};

export type BgpOutputValues = {
  communityList: string[];
  id: string;
  isVrfStd: boolean;
  protocol: BgpCommunitiesProtocol;
  sn: string;
  vrf: string | null;
};
